document.addEventListener('DOMContentLoaded', async () => {
  

     // Function to get the value of a cookie by name
    function getCookieValue(cookieName) {

      const cookieString = document.cookie;
      const cookies = cookieString.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          return value != "undefined" ? value : null;
        }
      }
      return null;
    }


  
        const apiEndPoint = "aagasketapi.azurewebsites.net";
        // const apiEndPoint = "localhost:5244";
        const apiBaseUrl = `https://${apiEndPoint}`;
        const RECAPTCHA_SITE_KEY = window.RECAPTCHA_SITE_KEY || '';
        const RECAPTCHA_ACTION = 'rego_search';
        const SEARCH_COOLDOWN_MS = 8000;
        let searchCooldownUntil = 0;

        // Function to show loading spinner
        function showLoading() {
            const loadingSpinner = document.getElementById('loadingSpinner2');
            loadingSpinner.style.display = 'block';
        }
    
        // Function to hide loading spinner
        function hideLoading() {
            const loadingSpinner = document.getElementById('loadingSpinner2');
            loadingSpinner.style.display = 'none';
        }

        async function getRecaptchaToken() {
            if (!RECAPTCHA_SITE_KEY || typeof grecaptcha === 'undefined') {
                throw new Error('Security check is unavailable. Please refresh the page and try again.');
            }

            await new Promise((resolve) => grecaptcha.ready(resolve));
            const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: RECAPTCHA_ACTION });
            if (!token) {
                throw new Error('Security check failed. Please try again.');
            }
            return token;
        }

        function setSearchButtonDisabled(disabled) {
            const searchButton = document.getElementById('searchButton');
            if (searchButton) {
                searchButton.disabled = disabled;
            }
        }

        function startSearchCooldown() {
            searchCooldownUntil = Date.now() + SEARCH_COOLDOWN_MS;
            setSearchButtonDisabled(true);
            setTimeout(() => {
                if (Date.now() >= searchCooldownUntil) {
                    setSearchButtonDisabled(false);
                }
            }, SEARCH_COOLDOWN_MS);
        }

        // Consolidated fetch function with error handling
        async function fetchApiData(url, options = {}) {
            try {
                const response = await fetch(url, {
                  headers: {
                    'xuserid': getCookieValue('xuserid')
                  },
                    credentials: 'include',
                    ...options,
                });
    
                if (!response.ok) {
                    let message = `HTTP error! Status: ${response.status}`;
                    try {
                        const errorData = await response.json();
                        if (errorData && errorData.Message) {
                            message = errorData.Message;
                        }
                    } catch (parseError) {
                        // Keep the status-based message when the body is not JSON.
                    }
                    throw new Error(message);
                }

                const responseData = await response.json();
                // Set the 'xuserid' cookie with the value from the response
                document.cookie = `xuserid=${responseData.xuserid}; path=/`;
              
                return responseData;
            } catch (error) {
                throw new Error(`Error during fetch: ${error.message}`);
            }
        }
    
        // Functions for Rego and VIN searches
        async function regoSearch(state, rego, token) {
            const url = `${apiBaseUrl}/AutoInfoSearchAU/VehicleByLicencePlateD?Licenceplate=${encodeURIComponent(rego)}&State=${encodeURIComponent(state)}&Token=${encodeURIComponent(token)}`;
            return await fetchApiData(url);
        }
    
        async function vinSearch(vin, token) {
            const url = `${apiBaseUrl}/AutoInfoSearchAU/SearchByVinNumber?vinString=${encodeURIComponent(vin)}&Token=${encodeURIComponent(token)}`;
            return await fetchApiData(url);
        }
    
        // Function to render vehicles table
        function renderVehiclesTable(vehicles, searchType) {
            const container = document.getElementById('vehicle-search-result');
            document.getElementById('resultsContainer2').innerHTML='';
    
            // Create the table element
            const table = document.createElement('table');
            table.classList.add('table', 'table-striped'); // Example classes for styling
    
            // Create the table header
            const headerRow = table.insertRow();
            const headerCells = ['Make', 'Model', 'Year', 'Series', 'Body', 'Transmission', 'Engine']; // Adjust headers as needed
            headerCells.forEach(header => {
                const headerCell = headerRow.insertCell();
                headerCell.textContent = header;
            });
    
            // Create rows for each vehicle
            vehicles.forEach(vehicle => {
                const row = table.insertRow();
    
                const makeCell = row.insertCell();
                makeCell.textContent = vehicle.make;
    
                const modelCell = row.insertCell();
                modelCell.textContent = vehicle.model;
    
                const yearCell = row.insertCell();
                yearCell.textContent = vehicle.year;
    
                const seriesCell = row.insertCell();
                seriesCell.textContent = vehicle.series; // Map to the appropriate property
    
                const bodyCell = row.insertCell();
                bodyCell.textContent = vehicle.body;
    
                const transmissionCell = row.insertCell();
                transmissionCell.textContent = vehicle.transmission;
    
                const engineCell = row.insertCell();
                engineCell.textContent = vehicle.engine;
            });
    
            // Clear any existing content in the container
            container.innerHTML = '';
    
            // Add click event listener only to body rows (excluding the header)
            const bodyRows = table.querySelectorAll('tr:not(:first-child)');
            bodyRows.forEach(row => {
                row.classList.add('clickable' ,'cursor-pointer');
                row.addEventListener('click', (event) => {
                  event.stopPropagation();
            
                  // Get the intended row element reliably:
                  const intendedRow = event.target.closest('tr');
            
                 // console.log("intended_row",intendedRow);
                  if (intendedRow) {
                    const rowIndex = intendedRow.rowIndex;
                    let adjustedIndex = rowIndex - 1; // Account for header and potential extra rows
            
                    // Adjust for additional rows:
                    if (table.querySelectorAll('tr:not(:first-child):not(:last-child)').length > bodyRows.length) {
                      adjustedIndex--;
                    }
            
                    // Validate index:
                    if (adjustedIndex >= 0 && adjustedIndex < vehicles.length) {
                      const rowData = vehicles[adjustedIndex];
                      showLoading();
                      if (searchType === 'rego') {
                       
                        // Append a new result div
                        //const resultDiv = document.createElement('div');
                        //resultDiv.id = 'vehicle-details'; // Example ID
                        // Populate the result div with content (e.g., using rowData)
                        //container.appendChild(resultDiv);
                       // console.log("vehicle_data",rowData);    
                        const apiUrl = `${apiBaseUrl}/AutoInfoSearchAU/GetSearchResultsByKey?vehicleId=${rowData.vehicleIdEncrypted}`;
                        fetchApiData(apiUrl)
                            .then(async data => {
                                if (data) {
                                    //console.log("data_", data);
                                    // Populate the page with fetched data
                                    document.getElementById('vehicle-search-result').style.display = 'none';
                                    populatePageWithData(data.model,'resultsContainer2');
                                    // Show the result div
                                    document.getElementById('resultDiv').style.display = 'block';
                                    // Hide the no parts found message
                                    document.getElementById('noPartsFound2').style.display = 'none';
                                } else {
                                    // Show the no parts found message
                                    document.getElementById('noPartsFound2').style.display = 'block';
                                    // Hide the result div
                                    document.getElementById('resultDiv').style.display = 'none';
                                }
                                hideLoading();
                            });
                    } else {
                        // Redirect to the other page
                       // window.location.href = `/search-results?make=${rowData.make}&model=${rowData.model}`;
                        const apiUrl = `${apiBaseUrl}/AutoInfoSearchAU/GetSearchResultsByKey?vehicleId=${rowData.vehicleIdEncrypted}`;
                        fetchApiData(apiUrl)
                            .then(data => {
                                if (data) {
                                    //console.log("data_", data);
                                    // Populate the page with fetched data
                                    document.getElementById('vehicle-search-result').style.display = 'none';
                                    populatePageWithData(data.model,'resultsContainer2');
                                    // Show the result div
                                    document.getElementById('resultDiv').style.display = 'block';
                                    // Hide the no parts found message
                                    document.getElementById('noPartsFound2').style.display = 'none';
                                } else {
                                    // Show the no parts found message
                                    document.getElementById('noPartsFound2').style.display = 'block';
                                    // Hide the result div
                                    document.getElementById('resultDiv').style.display = 'none';
                                }
                                hideLoading();
                            });
                    }
            
                      // Highlight the selected row
                      const rows = table.querySelectorAll('tr');
                      rows.forEach(row => row.classList.remove('selected'));
                      intendedRow.classList.add('selected');
            
                      //console.log('Vehicle clicked:', rowData);
                    } else {
                      console.error("Invalid row index:", adjustedIndex); // Handle invalid index
                    }
                  } else {
                    console.error("Could not determine row index from event target."); // Handle cases where intended row is not found
                  }
                });
              });;
    
            // Append the table to the container
            container.appendChild(table);
            container.style.display="block";
            // Add the "clickable-row" class to body rows for cursor change
            bodyRows.forEach(row => row.classList.add('clickable-row'));
            // ... (rest of the code)
        }
    
        // Function to handle search button click
        document.getElementById('searchButton').addEventListener('click', async () => {
            if (Date.now() < searchCooldownUntil) {
                showError('Please wait a few seconds before searching again.');
                return;
            }

            resetResults();
            showLoading();
            setSearchButtonDisabled(true);
            const regoNo = document.getElementById('regoNo').value.trim();
            const regoState = document.getElementById('regoStateAU').value.trim();
            const vinNo = document.getElementById('vinNo').value.trim();
    
            try {
                if (regoNo && regoState) {
                    const token = await getRecaptchaToken();
                    const apiResult = await regoSearch(regoState, regoNo, token);
                    handleApiResult(apiResult.model, "rego");
                    startSearchCooldown();
                } else if (vinNo) {
                    const token = await getRecaptchaToken();
                    const apiResult = await vinSearch(vinNo, token);
                    handleApiResult(apiResult.model, "vin");
                    startSearchCooldown();
                } else {
                    showError('Please provide either Rego no. and State or VIN no.');
                    setSearchButtonDisabled(false);
                }
                hideLoading();
            } catch (error) {
                hideLoading();
                setSearchButtonDisabled(false);
                showError(error.message); // Display specific error message
                console.error(error);
            }
        });
    
        // Function to reset results and errors
        function resetResults() {
            const container = document.getElementById('vehicle-search-result');
            container.innerHTML = '';
        }
    
        // Function to handle API result
        function handleApiResult(apiResult, searchType) {
            //console.log("Result", apiResult);
            if (Array.isArray(apiResult.vrqResult)) {
               // if(apiResult.vrqResult.length>1)
                renderVehiclesTable(apiResult.vrqResult, searchType);
            // if(apiResult.vrqResult.length==1){
            //     const apiUrl = `https://${apiEndPoint}/AutoInfoSearchAU/GetSearchResultsByKey?vehicleId=${apiResult.vrqResult[0].vehicleIdEncrypted}`;
            //     window.open(apiUrl, '_blank');   
            // }
            
            } else {
                showError('Invalid API response format.');
            }
        }
    
          document.getElementById('rresetId').addEventListener('click', function ()  {
            const regoNo = document.getElementById('regoNo');
            const regoState = document.getElementById('regoStateAU');
            const vinNo = document.getElementById('vinNo');
            regoNo.value = '';
            regoState.selectedIndex = 0;
            vinNo.value = '';
            const resultsContainer = document.getElementById('resultsContainer2');
            const container = document.getElementById('vehicle-search-result');
            container.innerHTML='';
            resultsContainer.innerHTML = '';
        })
        // Function to show error message
        function showError(message) {
            const container = document.getElementById('vehicle-search-result');
            container.innerHTML = `<p>${message}</p>`;
        }


        // Function to fetch product details and open modal
async function  fetchProductDetailsAndOpenModal(product) {
    console.log("Product", product);
    return await updateModalContent(product);
  }
  
  // Function to update modal content with product details
  async function  updateModalContent(productDetails) {
    //const modalContent = document.getElementById('modal-quick-view');
   
    // Update modal content based on productDetails
    
      return  `
      <div class="modal-header">
          <h2 class="modal-title" id="productModalLabel">Product Details</h2></div>
      <div class="modal-body">
      <div class="row">
      <div class="col-md-6">
      <img src="https://api.autoinfo.com.au${productDetails.imageUrl}" class="img-fluid" alt="Image">
      </div>
      <div class="col-md-6">
      <p class="card-text mb-0"><span class="text-primary"><strong>Product Name:</strong></span> ${productDetails.partNo}</p>
      <p class="card-text mb-0"><span class="text-primary"><strong>Product Description:</strong></span> ${productDetails.partDesc}</p>
      ${productDetails.footnote === productDetails.longFootnote ? 
        (productDetails.footnote ? 
          `<p class="card-text mb-0"><span class="text-primary"><strong>Note1:</strong></span> ${productDetails.footnote}</p>` : 
          '') :
        (productDetails.footnote ? 
          `<p class="card-text mb-0"><span class="text-primary"><strong>Note1:</strong></span> ${productDetails.footnote}</p>` : 
          '') +
        (productDetails.longFootnote ? 
          `<p class="card-text mb-0"><span class="text-primary"><strong>Note2:</strong></span> ${productDetails.longFootnote}</p>` : 
          '') 
      }  
      </div>
      </div>
      </div>
      
      `;
   
  
      
   
  }
    });
    